
  class PincodeChecker extends HTMLElement {
    constructor() {
      super();
      this.pincodeInput = this.querySelector('[name="pincode-input"]');
      this.pincodeSubmitBtn = this.querySelector('[name="pincode-submit"]');
      this.pincodeMessage = this.querySelector('[name="pincode-message"]');
      this.sku = this.dataset.sku;

      this.loadLastPincode();

      this.pincodeSubmitBtn.addEventListener('click', this.validatePincode.bind(this));
      this.pincodeInput.addEventListener('focus', this.moveCursorToEnd.bind(this));
      this.pincodeInput.addEventListener('keypress', this.validateInput.bind(this));
      this.pincodeInput.addEventListener('keydown', this.handleBackspace.bind(this));

      this.pincodeInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.validatePincode();
        }
      });
    }

    validatePincode() {
      const pincode = this.pincodeInput.value.trim();
      if (pincode.length === 6) {
        this.fetchEstimatedDeliveryFromAPI(pincode, this.sku);
      } else {
        this.showError("Please enter a valid pincode");
      }
    }

    fetchEstimatedDeliveryFromAPI(pincode, sku) {
      const apiUrl = `https://api.openleaf.tech/api/v1/custom_pincodes/closestTATUnicommerce?pincode=${pincode}&sku=${sku}`;
      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer 025f23eaa925b4471e46d57cd3367b77'
        }
      })
      .then(response => response.json())
      .then(result => {
        const values = result?.values;
        console.log("API response values:", values);

       if (values && values.length >= 4 && values[2] === 'true') {
      let today = new Date();
      let estimatedDayResponse = parseInt(values[0]) + 2; // Add buffer of 2 days
      let estimatedDate = new Date();
      estimatedDate.setDate(estimatedDate.getDate() + estimatedDayResponse);
      
      // If the estimated delivery falls on a Sunday (0), add 1 more day
      if (estimatedDate.getDay() === 0) {
        estimatedDate.setDate(estimatedDate.getDate() + 1);
      }

 
  let estimatedDeliveryDate = estimatedDate.toLocaleDateString("en-IN", {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
  });

  const warehouseName = values[3] || 'Warehouse';

  const successHtml = `
    <div class="pincode-message__item">
      <div class="pincode-message__item-container">
        <!-- SVG icon omitted for brevity -->
        <p><strong>Estimated Delivery By:</strong> ${estimatedDeliveryDate}</p> 
       
      </div>
    </div>`;

      this.pincodeMessage.innerHTML = successHtml;
      this.pincodeMessage.classList.add('is-success');
      this.pincodeMessage.classList.remove('is-error', 'is-hidden');
    
      localStorage.setItem("lastPincode", pincode);
    }
     else {
          this.showError("Delivery info not available for this pincode.");
        }
      })
      .catch(error => {
        console.error("API error:", error);
        this.showError("Unable to fetch delivery info.");
      });
    }

    showError(message) {
      this.pincodeMessage.textContent = message;
      this.pincodeMessage.classList.add('is-error');
      this.pincodeMessage.classList.remove('is-success', 'is-hidden');
    }

    loadLastPincode() {
      const lastPincode = localStorage.getItem("lastPincode");
      if (lastPincode) {
        this.pincodeInput.value = lastPincode;
        this.validatePincode();
      }
    }

    moveCursorToEnd() {
      const val = this.pincodeInput.value;
      this.pincodeInput.value = '';
      this.pincodeInput.value = val;
    }

    validateInput(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    }

    handleBackspace(e) {
      if (e.key === 'Backspace' && this.pincodeInput.value.length === 0) {
        e.preventDefault();
      }
    }
  }

  customElements.define('pincode-checker', PincodeChecker);
